/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AppointmentFormatEnum = {
    VideoCall: 'VIDEO_CALL',
    PhoneCall: 'PHONE_CALL',
    OnSite: 'ON_SITE'
} as const;
export type AppointmentFormatEnum = typeof AppointmentFormatEnum[keyof typeof AppointmentFormatEnum];

